import axios from "@/api/axiosAuthRequired.js"
import baseaxios from "axios"
import store from "../store/index.store"

const INSTAPRO_API_URL = process.env.INSTAPRO_API_URL
const PROGUIDES_WEB_URL = process.env.PROGUIDES_WEB_URL

export const getVodPrice = async () => {
  try {
    const res = await axios.get(
      `${INSTAPRO_API_URL}api/v1/requests/async-vod-review/pg-point`
    )
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const createVodRequest = async (body, getInstaProAccessToken) => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const res = await axios.post(
      `${PROGUIDES_WEB_URL}api/v2/instapro/session-async-requests`,
      body,
      {
        headers: {
          "Authorization": "Bearer " + clientCredentials,
          "X-INSTA-TOKEN": getInstaProAccessToken,
        },
      }
    )
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const fetchPickableVodRequests = async getInstaProAccessToken => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const res = await axios.get(
      `${PROGUIDES_WEB_URL}api/v2/instapro/session-async-requests/pickable`,
      {
        headers: {
          "Authorization": "Bearer " + clientCredentials,
          "X-INSTA-TOKEN": getInstaProAccessToken,
        },
      }
    )
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const retrievePreSignedUploadUrlByStudent = async (
  instaproAccessToken,
  gameId,
  fileExtension
) => {
  try {
    const config = {
      headers: {
        "Authorization": "Bearer " + instaproAccessToken,
        "Content-Type": "multipart/form-data",
      },
    }
    const url = `${INSTAPRO_API_URL}api/v1/student/requests/vod-reviews/upload-url?game_id=${gameId}&file_extension=${fileExtension}`
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}
export const retrievePreSignedUploadUrlByCoach = async (
  instaproAccessToken,
  requestId,
  fileExtension
) => {
  try {
    const config = {
      headers: {
        "Authorization": "Bearer " + instaproAccessToken,
        "Content-Type": "multipart/form-data",
      },
    }
    const url = `${INSTAPRO_API_URL}api/v1/coach/requests/vod-reviews/${requestId}/upload-url?file_extension=${fileExtension}`
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const uploadVideo = async (uploadUrl, video) => {
  try {
    const CancelToken = baseaxios.CancelToken
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: function (progressEvent) {
        var percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        )
        store.commit("Instapro/Vod/setUploadingProgress", percentCompleted)
      },
      cancelToken: new CancelToken(function executor (c) {
        store.commit("Instapro/Vod/setCancelUploadingFunction", c)
      }),
    }
    const res = await axios.put(uploadUrl, video, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error
  }
}
export const uploadVideoByCoach = async (uploadUrl, video) => {
  try {
    const CancelToken = baseaxios.CancelToken
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: function (progressEvent) {
        var percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        )
        store.commit(
          "Instapro/Vod/Coach/setUploadingProgress",
          percentCompleted
        )
      },
      cancelToken: new CancelToken(function executor (c) {
        store.commit("Instapro/Vod/setCancelUploadingFunction", c)
      }),
    }
    const res = await axios.put(uploadUrl, video, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error
  }
}

export const pickupVodRequest = async (requestId, instaProAccessToken) => {
  try {
    const url = `${INSTAPRO_API_URL}api/v1/coach/requests/${requestId}/pickup`
    const config = {
      headers: {
        Authorization: "Bearer " + instaProAccessToken,
      },
    }
    const res = await axios.put(url, null, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error
  }
}

export const fetchVodRequests = async (status, instaProAccessToken) => {
  try {
    let url = `${INSTAPRO_API_URL}api/v1/coach/requests/async`
    if (status) {
      url += `?status=${status}`
    }
    const config = {
      headers: {
        Authorization: "Bearer " + instaProAccessToken,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const completeVodRequest = async (
  requestId,
  data,
  instaProAccessToken
) => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const url = `${PROGUIDES_WEB_URL}api/v2/instapro/session-async-requests/${requestId}/complete`
    const config = {
      headers: {
        "Authorization": "Bearer " + clientCredentials,
        "X-INSTA-TOKEN": instaProAccessToken,
      },
    }
    const res = await axios.put(url, data, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error
  }
}

export const declineVodRequest = async (requestId, instaProAccessToken) => {
  try {
    const url = `${INSTAPRO_API_URL}api/v1/coach/requests/${requestId}/decline`
    const config = {
      headers: {
        Authorization: "Bearer " + instaProAccessToken,
      },
    }
    const res = await axios.put(url, null, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getStudentRequests = async instaProAccessToken => {
  try {
    const url = `${INSTAPRO_API_URL}api/v1/student/requests?type=ASYNC`
    const config = {
      headers: {
        Authorization: "Bearer " + instaProAccessToken,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const flagFeedbackRecommendation = async (
  recommendationId,
  body,
  instaProAccessToken
) => {
  try {
    const url = `${INSTAPRO_API_URL}api/v1/student/request-async-feedback-recommendation/${recommendationId}`
    const config = {
      headers: {
        Authorization: "Bearer " + instaProAccessToken,
      },
    }
    const res = await axios.put(url, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getVodAvailableGames = async () => {
  try {
    const url = `${INSTAPRO_API_URL}api/v1/requests/vod-reviews/available-games`
    const res = await axios.get(url)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const rateVodRequestAsStudent = async (
  requestId,
  body,
  instaProAccessToken
) => {
  try {
    const url = `${INSTAPRO_API_URL}api/v1/student/requests/${requestId}/rate`
    const config = {
      headers: {
        Authorization: "Bearer " + instaProAccessToken,
      },
    }
    const res = await axios.put(url, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error
  }
}

export const getAvailableLanguagesByGame = async gameId => {
  try {
    const url = `${INSTAPRO_API_URL}api/v1/requests/vod-reviews/available-languages-by-game/${gameId}`
    const res = await axios.get(url)
    return res.data
  } catch (error) {
    console.error(error)
    return error
  }
}

export const getAvailableCoachesByGame = async gameId => {
  try {
    const url = `${INSTAPRO_API_URL}api/v1/coaches?games[0]=${gameId}&filters[0]=ONLINE_OR_HAS_OPEN_SCHEDULE_SLOTS_THIS_WEEK&filters[1]=GPA_ENABLED`
    const res = await axios.get(url)
    return res.data
  } catch (error) {
    console.error(error)
    return error
  }
}



// WEBPACK FOOTER //
// ./src/api/vod.js